(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-form"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var form = document.getElementById('ContactForm');
    if (!form) return;
    var consent = document.getElementById('ContactForm-privacy');
    var submit = document.getElementById('ContactForm-submit');
    var err = document.getElementById('ContactForm-privacy-error');

    function toggleSubmit() {
      var ok = consent && consent.checked;
      if (ok) {
        submit.removeAttribute('disabled');
        submit.setAttribute('aria-disabled','false');
        err && err.classList.remove('is-visible');
      } else {
        submit.setAttribute('disabled','disabled');
        submit.setAttribute('aria-disabled','true');
      }
    }
    if (consent && submit) {
      toggleSubmit();
      consent.addEventListener('change', toggleSubmit);
      form.addEventListener('submit', function(e){
        if (!consent.checked) {
          e.preventDefault();
          err && err.classList.add('is-visible');
          consent.focus();
        }
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      // Header sofort sticky machen wenn "always" oder "reduce-logo-size" ausgewählt
      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
  // GA4 Hero Button Tracking
  document.addEventListener('DOMContentLoaded', function() {
    // Hero Buttons im Slideshow-Bereich finden
    const heroButtons = document.querySelectorAll('.slideshow .banner__buttons a.button');
    
    heroButtons.forEach(button => {
      const buttonText = button.textContent.trim();
      const buttonHref = button.getAttribute('href');
      
      // Prüfe auf spezifische Buttons
      if (buttonText === 'Jetzt konfigurieren' || buttonText.includes('konfigurieren')) {
        button.addEventListener('click', function(e) {
          if (typeof gtag !== 'undefined') {
            gtag('event', 'hero_jetzt_konfigurieren_click', {
              'event_category': 'hero',
              'event_label': 'Jetzt konfigurieren',
              'button_text': buttonText,
              'button_url': buttonHref || '',
              'page_location': window.location.href
            });
          }
        });
      } else if (buttonText === 'Zu den fertigen Kästen' || buttonText.includes('fertigen Kästen') || buttonText.includes('fertige Kästen')) {
        button.addEventListener('click', function(e) {
          if (typeof gtag !== 'undefined') {
            gtag('event', 'hero_zu_den_fertigen_kaesten_click', {
              'event_category': 'hero',
              'event_label': 'Zu den fertigen Kästen',
              'button_text': buttonText,
              'button_url': buttonHref || '',
              'page_location': window.location.href
            });
          }
        });
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
